$(document).ready(function(){       
       // fpr product-loop
       add_variant_buttons();   
       infinite_slide(".gallery_product", ".product_slide_container");
       //trim_desc();
       resize_product_slides_and_container(".gallery_product", ".product_slide_container");
       
       // for single product page
       resize_thumbs();
       
       // getCart
       Shopify.getCart(update_cart);
       
       // general
       add_events_handlers();
       
       add_language_controls();
       language_switch("eng");   
       	
});


function add_language_controls(){
       $(".add_lang_controls").after('<div class="cropped language_select"><p class="eng">E</p><p class="deu">D</p></div>');
};

function language_switch(l){
       $(".language_select p, .lang div, .lang p").removeClass("selected");
       $(".lang div."+l+", .lang p."+l).addClass("selected");
       $(".language_select p."+l).addClass("selected");
};

$(window).resize(function(){
       resize_product_slides_and_container(".gallery_product", ".product_slide_container");
        
       if( $(window).width() >= 700 ){
              $('.main_nav:hidden').show();       
       }else{
              $('.main_nav').hide();
       }
       
       $(".mousetrap").width($(".span6").width());
       
       zoom_box();
});

// EVENT HANDLERS
function add_events_handlers(){
       // CART
       $(".addtocart").click(function(e){
              var i = $(this).closest(".gallery_product").find(".product_slide_container li.first img").attr("src");
              Shopify.getCart();
       });       
       $( "body #cart" ).on( "click", ".remove", function() {
              var id = $(this).closest(".mini_item").attr("data_id");
              Shopify.removeItem(id,update_cart);
       });
       $( "body #cart" ).on( "change", ".qty", function() {
              var id = $(this).closest(".mini_item").attr("data_id");
              var value = $(this).attr("value");
              Shopify.changeItem(id,value,update_cart);
              
       });

       //MENU
       // mobile menu ein / ausblenden
       $("body").delegate( ".toggle_menu", "click", function() {
              hide_overlay();
              toggle_menu();
       });
       // mobile menu ausblenden bei click außerhalb und unter 700px breite
       $(document).click(function(event) { 
              if(!$(event.target).closest('.main_nav').length && !$(event.target).hasClass("toggle_menu") && $(window).width() <= 700 ){
                  if($('.main_nav').is(":visible")) {
                      $('.main_nav').hide();
                  }
              }        
       });
       
       // POPUPS
       $("body").delegate( ".overlay", "click", function() {
              hide_overlay();
       });
       
       $("#cart").click(function(e){
              e.preventDefault();
              popup("cart_popup");       
       });
       $(".customer_login_link, .login").click(function(e){
              e.preventDefault();
              popup("login_popup");
       });
       
       $(".customer_register_link, .register").click(function(e){
              e.preventDefault();
              popup("register_popup");
       });
	   $(".your_account, .account").click(function(e){
              e.preventDefault();
              popup("account_popup");
       });

       //SPRACHE
       $("body").delegate(".language_select p:not(.selected)", "click", function(){
              language_switch($(this).attr("class"));
       });
       
};

// MENU
function toggle_menu(){
  $(".main_nav").toggle();
};


// CART

Shopify.onCartUpdate = function(cart) {
	update_cart(cart,false);
};

Shopify.onVariant = function(product, variant_id) {
		for(var i = 0; i < product.variants.length; i++){
			
			if(product.variants[i].id == variant_id){
				
				variant_title = product.variants[i].title;	
				//alert(variant_title);

				for(var j = 0; j < product.images.length; j++){
					
					if (product.images[j].indexOf(variant_title) >= 0)
					{
						return product.images[j];
					}

				}

			}
		}
};


function update_cart(cart,manual){
       if (manual === undefined){
              manual = true;
       }
       var output = "";
       var items = cart.items;
       var item;

       
       for(var i = 0; i < items.length; i++){
              item = items[i];
              
              //get_variant(item.variant_id);
			  Shopify.getVariant(item.handle,item.variant_id);

              output +=      "<div class='mini_item row clearfix0' data_id='"+item.variant_id+"'>";
              output +=      "<h2 class='left title'>"+item.title+"</h2>";
              output +=            "<img class='right' src='' alt=''/>";
              output +=            "<div class='left'>";
              output +=                   "<h3 class='calc'><input class='qty' type='text' name='quant' value='"+item.quantity+"'/><span class='multiply'></span><span class='price'>€ "+format_money(item.price)+"</span></h3>";
              output +=                   "<h3 class='line_price'>€ "+format_money(item.line_price)+"</h3>";
              output +=                          "<p class='btn secondary remove' ></p>";
              output +=            "</div>";
              output +=     "</div>";
       }
       
       output += "<h3 class='total'>€ "+format_money(cart.total_price)+"</h3>";
       output += "<a class='btn' href='https://checkout.shopify.com/carts/5551885/"+cart.token+"'>checkout</a>";
       $(".small_cart").html(output);
       
       if(manual === true){
              // manual cart update  (when changing number of items out of cart popup)
              var current = $("#cart-count").text(cart.item_count);
       }
};


// ---------------------------------------------------------
// GET products/<product-handle>.js returns the product in JSON.
// ---------------------------------------------------------
Shopify.getVariant = function(handle, variant_id, callback) {
	
  	jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
	
		variantImage = Shopify.onVariant(product, variant_id);
		
		// insert "_medium" before ".jpg"  to get small version of image
		extensionPos = variantImage.indexOf("jpg");
		variantImageName = variantImage.substr(0,extensionPos - 1);
		extension = variantImage.substr(extensionPos-1);
		mediumVariantImage = variantImageName + "_medium" + extension;

		$(".mini_item[data_id = '" + variant_id + "']").find("img").attr("src",mediumVariantImage);
		
		$(".mini_item[data_id = '" + variant_id + "']").find("img").load(function(){
				$(".mini_item[data_id = '" + variant_id + "']").animate({
              		opacity: 1
					}, 500, function() {
						
						});
				})
  	});
};



function format_money(str){
        var str = str.toString();      
	var t = str.length - 5;
	var h = str.length - 2;

	var t_str ="";
	var h_str ="";
	var c_str ="";
	
	if(t >= 1){
		t_str = str.substr(0,t)+",";
		//log("t_str",t_str);
	}else{

	}
	h_str = str.substr(t,h - t)+".";
	//log("h_str",h_str);
	
	c_str = str.substr(h);
	//log("c_str",c_str);
	
	var	output = t_str+h_str+c_str;
	return(output);
}



// SINGLE PRODUCT 

function resize_thumbs(){
       var num_thumbs = $(".thumbs").find(".image").length;
       log("num_thumbs",num_thumbs);
      
       $(".thumbs").find(".image").css("width",100 / num_thumbs +"%");
};








// SLIDEOUT POPUPS
function popup(target){
       
       if( $(window).width() <= 700 ){
              $(".main_nav").hide();
       }
       
       if($(".overlay").length === 0){
              $("body").prepend('<div class="overlay"></div>');       
       }
       
       if($("#"+target).hasClass("open")){
              hide_overlay();
       }       
       else if($(".popup").hasClass("open")){
              close_popup(target);
       }else{
              show_overlay();
              open_popup(target);
       }
       
       
}

function show_overlay(target){
       $(".logo").animate({
              top: parseInt($(".logo").css("top")) + 20
              }, 200, "easeOutQuart", function() {
                     
                     $(".overlay").animate({
                            opacity: 0.3
                            }, 500, "easeOutQuart", function() {

                     });
                     
                     open_popup(target);
       });
};

function open_popup(target){
       if( $("#"+target).hasClass("open") ){
              hide_overlay();
              //alert("open");
       }else{
              $("#" + target).css("display","block");
              $("#" + target).addClass("open");
              
              $("#popup_container").animate({
                     width: $(".popup").width()
                     }, 500, "easeOutQuart", function() {

              }); 

              $("#" + target).animate({
                     right: 0
                     }, 500, "easeOutQuart", function() {

              }); 
       }
};


function close_popup(new_target){
       
       $(".popup").animate({
              right: - $(".popup").width()
              }, 500, "easeInQuart", function() {
              $(".popup").css("display","none");
              $(".popup").removeClass("open");
       });
       $("#popup_container").animate({
              width:0
              }, 500, "easeInQuart", function() {
                     if(new_target){
                            open_popup(new_target);       
                     }
                     
       });
}

function hide_overlay(){
       $(".overlay").animate({
              opacity: 0
              }, 500, "easeInQuart", function() {
                     
              $(".overlay").remove();
              
              $(".logo").animate({
                     top: parseInt($(".logo").css("top")) - 20
                     }, 500, "easeOutQuart", function() {

              });
       });
       
       close_popup();
}






// PRODUCT SLIDESHOW
function add_variant_buttons(){
       // scale variant selection buttons
       $(".color_variants").each(function(index){
		var c = $(this).children("li").length;
		var w = 100 / c;
		$(this).children("li").css("width", w + "%");
       });
       
       // variant selection buttons functionality
       $(".color_variants").each(function(index){
              $(this).children("li").click(function(){
                     change_product_variant($(this),$(this).text());    
              });
              $(this).children("li").mouseover(function(){
                     change_product_variant($(this),$(this).text());    
              });
       });
       // for product-loop
       $(".product-select").on("change",function(){
              ele = $(this).children("option:selected");
              change_product_variant(ele,ele.attr("class"));    
       });
       
       // for single product page
       $(".single-option-selector").on("change",function(){
              ele = $(this).children("option:selected");
              change_single_product_variant(ele,ele.val());    
       });
};

function change_single_product_variant(target, variant){
       var product = $(ele).closest("#product"); 
       product.find(".thumbs .image a img[alt="+ variant +"]").trigger("click");
};

// CHANGE VARIANT IMAGE
function change_product_variant(target, variant){
       // find parent
       var p = target.closest(".gallery_product");
       //swap .active class
       p.find(".button.active").removeClass("active");
       p.find(".button."+variant).addClass("active");
       
       // and select option
       p.find(".product-select").find("option").prop('selected', false);
       p.find(".product-select").find("option."+variant).prop('selected', true);
       
       
       // remove .active from current slide_container
       p.find(".product_slide_container.active").removeClass("active");
       
       // find set new .active slide_container
       var new_active_container = p.find(".product_slide_container." + variant);
       new_active_container.addClass("active");
       
       // view .switch buttons if num_images > 1
       if(new_active_container.find(".slide").length > 1){
              p.find(".switch").css("display","block");
       }else{
              p.find(".switch").css("display","none");
       }
};

function resize_product_slides_and_container(parent,container){
       
       var container = $(container);
       var parent = $(parent);
       
// ADJUST DESC p.text HEIGHT
       // reset initial .desc height to enable it getting smaller overall
       parent.find(".desc p.excerpt").height("");
       
       // find highest .desc element > get height
       var max_desc_height = 0;
       parent.each(function(){
              if($(this).find(".desc p.excerpt").height() > max_desc_height){
                     max_desc_height = $(this).find(".desc p.excerpt").height();
                     log("new_max_desc_height",max_desc_height);
              }
       });
       // assign to all .desc
       parent.find(".desc p.excerpt").height(max_desc_height);
       
// SCALE CONTAINER 
       var img_ratio = 0.7;
       // scale to width
       if(parent.hasClass("scale_to_width")){
              var p_width = $(parent).width();  
              var calc_h = p_width / img_ratio;
              parent.find(".product_slide_area").height( calc_h );
              
              log("calc_h",calc_h);
              log("p_width",p_width);
       }
       // scale to height
       else{
              var p_width = parent.find(".product_slide_area").height() * img_ratio ;       
              log("p_width",p_width);
              parent.width(p_width);
       }
       
       
// SCALE IMAGES IN SLIDESHOW       
       container.find(".slide img").css("width", p_width);
       
       // each slideshow
       parent.each(function(){
              // each variant .slide_container
              $(this).find(".slide_container").each(function(){
                     // if more than one image
                     if($(this).find(".slide").length > 1 ){
                            // adjust slide_container offset
                            var position = $(this).find(".slide.current").index();
                            $(this).css("left",- p_width * position);      
                     }
                     set_container_width($(this),p_width);
              });
       });
};



function set_container_width(container,p_width){
       // count images and set container with to parent_width * number images
       var img_l = $(container).children(".slide").length;
       $(container).css("width", p_width * img_l );
};

function infinite_slide(parent,container){
       var p_width = $(parent).width();
       // scale images
       $(container).find('.slide img').css("width", p_width);
       
       // every product
       $(parent).each(function(index){
              // every variant slideshow
              $(this).find(container).each(function(index){
                     // if multiple images
                     if($(this).find(".slide").length > 1){
                            var container = $(this);
                            //clone first and last image
                            // add navigation elements
                            container.children('.slide').last().clone().addClass("clone").prependTo(container);//clone the last image and put it at the front 
                            container.children('.slide').not(".clone").first().clone().addClass("clone").appendTo(container);//clone the first image and put it at the end
                            container.children('.slide').not(".clone").first().addClass("first current");
                            container.children('.slide').not(".clone").last().addClass("last");
                            
                            //add .switch buttons if not already added
                            if(container.parent().find(".switch").length === 0 ){
                                   container.parent().prepend('<div class="switch prev button"> <p class="square"></p> </div>');
                                   container.parent().prepend('<div class="switch next button"> <p class="square"></p> </div>');       
                            }
                            // show .switch buttons .active has > 1 images
                            if(container.hasClass("active")){       
                                   container.siblings(".switch").css("display","block");
                            }   
                             
                            var position = $(this).children(".slide.current").index();
                            
                            set_container_width($(this),p_width);

                            //reset the slider so the first image is still visible              
                            if(position !== -1){       
                                   container.css({'left':-position*p_width+'px'});
                            }
                            //reset the slider so the first image is still visible              
                            else{
                                   container.css({'left':-1*p_width+'px'});
                            }
                     }
              });
       });      
       add_click_events();
}


function add_click_events(){
       $('.product_slide_area .prev').click(function(){
              prev($(this));
       });
       
       $('.product_slide_area .next').click(function(){
              next($(this));
       });
}


// slideshow buttons
var prev = function(button){
       var parent = button.closest(".slideshow");
       
       var imgWidth = parent.width();
       var container = parent.find(".slide_container.active");
      
       var imgCount = container.find('.slide').length;
       
       
       if(container.find(".slide.current").hasClass("first")){
              container.find(".slide.last").addClass("current");
              container.find(".slide.first").removeClass("current");
       }else{
              var new_current = container.find(".slide.current").prev(".slide");
              container.find(".slide.current").removeClass("current");
              new_current.addClass("current");
       }

       container.stop(true,true); //complete any animation still running  
       var newLeft = container.position().left+(1*imgWidth);//calculate the new position which is the current position plus the width of one image
       container.animate({'left':newLeft+'px'}, "easeOutQuart", function(){//slide to the new position
              if (Math.round(newLeft) === (0)) //if the slider is displaying the first image, which is the clone of the last image
                     {
                     container.css({'left':-(imgCount - 2)*imgWidth+'px'});//reset the slider back to the last image without animating 
                     }
              });

       return false;
};



var next = function(button){
       
       if(button === undefined){
              var parent = $("#main_slideshow");
              var imgWidth = parent.width();
              var container = parent.find(".slide_container");
       }else{
              var parent = button.closest(".slideshow");
              var imgWidth = parent.width();
              var container = parent.find(".slide_container.active");
       }
       
       var imgCount = container.find('.slide').length;

       if(container.find(".current").hasClass("last")){
              container.find(".slide.first").addClass("current");
              container.find(".slide.last").removeClass("current");
       }else{
              var new_current = container.find(".slide.current").next(".slide");
              container.find(".slide.current").removeClass("current");
              new_current.addClass("current");
       }

       container.stop(true,true); //complete any animation still running - in case anyone's a bit click happy... 
       var newLeft = container.position().left-(1*imgWidth);//calculate the new position which is the current position minus the width of one image

       container.animate({'left':newLeft+'px'}, "easeOutQuart", function(){//slide to the new position...
              if (Math.round(newLeft) <= (- (imgCount - 1 )*imgWidth)) //...and if the slider is displaying the last image, which is the clone of the first image...
                     {
                     container.css({'left':- 1*imgWidth+'px'});//...reset the slider back to the first image without animating 
                     }
              });
       return false;
};

function trim_desc(){
       $(".desc p").each(function(){
              
              var str = $(this).text();    
              var str = str.split('.', 1)[0];
              $(this).text(str + ".");
       });
}

// HELPERS

function mark(target){
       $(target).addClass("marked");
}
function log(key,value){
       //console.log(key + ": " + value);
}
String.prototype.trimToLength = function(m) {
  return (this.length > m) 
    ? jQuery.trim(this).substring(0, m).split(" ").slice(0, -1).join(" ") + "..."
    : this;
};